'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getLocation = getLocation;

var _reduxHistorySync = require('redux-history-sync');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function getLocation(_ref) {
  var to = _ref.to,
      href = _ref.href,
      location = _objectWithoutProperties(_ref, ['to', 'href']);

  return _extends({}, (0, _reduxHistorySync.parseUrl)(to || href), location);
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-history-component/lib/util.js
// module id = 1272
// module chunks = 0